import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { CardBloc } from '@kp/shared/components/cards/card.bloc';
import { CardDisplayType, CardEventType, CardRequestType } from '@ktypes/enums';
import { CardEvent, CardItem } from '@ktypes/models';
import { MockComponent } from '@kutil/test';

const ANIMATION_DURATION = 1417; // 1:25s

@Component({
  selector: 'kp-animation-card',
  templateUrl: './animation-card.component.html',
  styleUrls: ['./animation-card.component.scss'],
})
export class AnimationCardComponent implements OnInit {
  @Input() card: CardItem;
  @Input() displayType: CardDisplayType;
  @Input() requestType: CardRequestType;

  canvasHeight = 180;
  canvasWidth = 314;
  cardDisplayType = CardDisplayType;
  playAnimation = true;

  @HostBinding('class.use-alternate')
  useAlternate: boolean;

  constructor(private _cardBloc: CardBloc) {}

  ngOnInit() {
    // use generic alternate if no WASM support
    this.useAlternate = typeof WebAssembly !== 'object';

    if (this.useAlternate || this.displayType === CardDisplayType.checklist) {
      setTimeout(() => this.loaded(), 1400);
    }
  }

  loaded() {
    setTimeout(() => {
      void this._cardBloc.handleCardEvents(
        new CardEvent(this.card.id, this.card, CardEventType.ANIMATION_COMPLETE, this.requestType)
      );
    }, ANIMATION_DURATION);
  }
}

export const MockAnimationCardComponent = MockComponent({
  selector: 'kp-animation-card',
  inputs: ['card', 'displayType', 'requestType'],
});
